/** Shared loader options for @react-google-maps/api (Loader is a process-wide singleton). */
export const V2_GOOGLE_MAPS_LOADER_ID = 'google-map-script';
export const V2_GOOGLE_MAPS_LIBRARIES = ['places'];
